export default __webpack_public_path__ + "static/media/Vambraces of the Black Warden.507ce86f.jpg";